<template>
  <div>
    <v-toolbar v-if="deleteDialog != true">
      <v-btn
        v-if="orderStepper != 1"
        icon
        @click="backPrevious"
      >
        <!-- class="hidden-xs-only" -->
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <v-toolbar-title v-if="deleteDialog != true">
        {{ titles[orderStepper] }}
      </v-toolbar-title>

      <v-btn
        v-if="orderStepper == 1"
        style="margin-left: auto;"
        icon
        @click="submitSearch"
      >
        <!-- class="hidden-xs-only" -->
        <v-icon>mdi-arrow-right-top-bold</v-icon>
      </v-btn>

      <v-btn
        v-if="orderStepper == 3"
        style="margin-left: auto;"
        icon
        @click="submitLocation"
      >
        <!-- class="hidden-xs-only" -->
        <v-icon>mdi-content-save</v-icon>
      </v-btn>

      <v-btn
        v-if="orderStepper == 5 && (!calculated)"
        style="margin-left: auto;"
        icon
        @click="submitEdit"
      >
        <v-icon>mdi-content-save</v-icon>
      </v-btn>

      <v-btn
        v-if="orderStepper == 6"
        style="margin-left: auto;"
        icon
        @click="submitSalesEdit"
      >
        <!-- class="hidden-xs-only" -->
        <v-icon>mdi-content-save</v-icon>
      </v-btn>
    </v-toolbar>

    <div v-if="orderStepper == 1 && deleteDialog != true">
      <v-card class="mt-5 mb-8">
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-menu
                  ref="fromMenu"
                  v-model="fromMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fromDate"
                      label="From Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fromDate"
                    type="date"
                    no-title
                  >
                  </v-date-picker>
                </v-menu>

                <v-menu
                  ref="toMenu"
                  v-model="toMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="toDate"
                      label="To Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="toDate"
                    type="date"
                    no-title
                  >
                  </v-date-picker>
                </v-menu>

                <v-text-field
                  v-model="searchKeyWord"
                  label="StudentName or MobileNo"
                  prepend-inner-icon="mdi-magnify"
                ></v-text-field>


                <v-text-field
                v-model="searchCoachKeyWord"
                label="Coach Name / MobileNo / OrderNo"
                prepend-inner-icon="mdi-magnify"
              ></v-text-field>

                <v-checkbox
                  v-model="calculatedCheckBox"
                  label="Calculated"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </div>
    <div v-else-if="orderStepper == 2 && deleteDialog != true">
      <swipe-list
        ref="swipeList"
        class="card"
        :disabled="!enabled"
        :items="content.items"
        item-key="id"
        :revealed.sync="revealed"
        :item-disabled="({ disabled }) => disabled"
        @closed="setLastEvent('closed', $event)"
        @leftRevealed="setLastEvent('leftRevealed', $event)"
        @rightRevealed="setLastEvent('rightRevealed', $event)"
      >
        <template v-slot="{ item, index, revealLeft, revealRight, close, revealed, disabled }">
          <!-- item is the corresponding object from the array -->
          <!-- index is clearly the index -->
          <!-- revealLeft is method which toggles the left side -->
          <!-- revealRight is method which toggles the right side -->
          <!-- close is method which closes an opened side -->
          <div
            ref="content"
            class="card-content"
          >
            <v-list-item>
              <v-list-item-avatar>
                <!-- class="grey lighten-1 white--text" -->
                <v-img
                  :src="avatarGetLink(item.userRecord.avatar)"
                  shape="circle"
                />
                <!-- <v-icon

      v-text="`mdi-account`"
    ></v-icon> -->
              </v-list-item-avatar>
              <v-list-item-content>
                <!-- class="font-weight-bolder" -->

                <v-list-item-subtitle
                  style="font-weight: 100"
                  v-text="item.orderNo"
                ></v-list-item-subtitle>
                <v-list-item-title
                  class="font-weight-black"
                  v-text="item.userRecord.fullName"
                ></v-list-item-title>
                <v-list-item-title v-text="item.course.courseName"></v-list-item-title>
                <v-list-item-subtitle v-text="`Total : $${item.totalAmount}`"></v-list-item-subtitle>
                <v-list-item-subtitle
                  v-text="`Session : ${item.sessionTotal - item.bookedCourse.length}/${item.sessionTotal}`"
                ></v-list-item-subtitle>
                <v-list-item-subtitle v-text="`Expriy Date : ${formatDate(item.expiryDate)}`"></v-list-item-subtitle>
                <v-list-item-subtitle v-text="`Coach : ${item.orderCoach.map(coach => coach.userRecord.fullName).join(', ')}`"></v-list-item-subtitle>

              </v-list-item-content>
            </v-list-item>
          </div>
        </template>

        <template v-slot:right="{ item }">
          <div
            class="swipeout-action blue"
            @click="edit(item)"
          >
            <v-icon
              large
              color="white"
            >
              mdi-format-list-bulleted-square
            </v-icon>
          </div>
          <div
            class="swipeout-action red  "
            @click="submitDelete(item)"
          >
            <v-icon
              large
              color="white"
            >
              mdi-trash-can
            </v-icon>
          </div>
        </template>
        <template v-slot:empty>
          <div>
            <!-- change mockSwipeList to an empty array to see this slot in action  -->
            list is empty ( filtered or just empty )
          </div>
        </template>
      </swipe-list>
    </div>
    <div v-else-if="orderStepper == 3 && deleteDialog != true">
      <OrderPrintView
        v-show="false"
        ref="orderPrintView"
        :order-id="reviewData.id"
      ></OrderPrintView>
      <!-- #Order Detail -->
      <v-card class="mt-5 mb-8">
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6">
                <v-card-text
                  class="pl-2 vcenter "
                  tile
                >
                  <b>Center </b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <universal-input
                  v-model="tempCenterCode"
                  :config="inputCenterConfig"
                ></universal-input>
              </v-col>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <b>Order No </b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  {{ reviewData.orderNo }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <b>Membership No </b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  {{ reviewData.userRecord.userNo }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <b>Membership Name </b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  {{ reviewData.userRecord.fullName }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <b>Gender </b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  {{ reviewData.userRecord.gender }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <b>HKID</b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  {{ reviewData.userRecord.hkid }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <b>Telephone</b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  {{ reviewData.userRecord.mobileNo }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <b>Email</b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  {{ reviewData.userRecord.email }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <b>Promotion</b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  {{ reviewData.promotionID ? reviewData.promotion.fullName : 'none' }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <b>Course</b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  {{ reviewData.course.courseName }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <b>Program</b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  {{ reviewData.sessionTotal }}/{{ reviewData.sessionTotal }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <b>Total Amount</b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  {{ reviewData.totalAmount }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <b>Effective Date</b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  {{ reviewData.effectiveDate ?
                    formatDate(reviewData.effectiveDate) : ''
                  }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <b>Expiry Date</b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  {{ reviewData.expiryDate ?
                    formatDate(reviewData.expiryDate) : ''
                  }}
                </v-card-text>
              </v-col>

              <v-col cols="12">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <div
                    style="color:#3467eb;"
                    @click="submitCommissionPage"
                  >
                    <u>Assigned Coach / Salesman Commission Percentage</u>
                  </div>
                </v-card-text>

                <!-- <v-btn color="#3467eb" left plain @click="submitConditionPage">

                  <u>Terms & Condition</u>
                </v-btn> -->
              </v-col>

              <v-col cols="12">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <div
                    style="color:#3467eb; "
                    @click="submitConditionPage"
                  >
                    <u>Terms & Condition</u>
                  </div>
                </v-card-text>
              </v-col>
              <v-col cols="12">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <div
                    style="color:#3467eb; "
                    @click="handlePrint"
                  >
                    <u>Print Order</u>
                  </div>
                </v-card-text>
              </v-col>
            </v-row>

            <v-btn
              color="#F48FB1"
              absolute
              bottom
              right
              fab
              @click="submitDelete(reviewData)"
            >
              <v-icon color="white">
                mdi-trash-can
              </v-icon>
            </v-btn>
          </v-container>
        </v-card-text>
      </v-card>
    </div>

    <div v-else-if="orderStepper == 4">
      <v-card class="mt-5 mb-8">
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <b>Order No </b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  {{ reviewData.orderNo }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <b>Membership No </b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  {{ reviewData.userRecord.userNo }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <b>Membership Name </b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  {{ reviewData.userRecord.fullName }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <b>Gender </b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  {{ reviewData.userRecord.gender }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <b>Course</b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  {{ reviewData.course.courseName }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <b>Program</b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  {{ reviewData.sessionTotal }}/{{ reviewData.sessionTotal }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <b>Total Amount</b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  {{ reviewData.totalAmount }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <b>Effective Date</b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  {{
                    reviewData.effectiveDate ?
                      formatDate(reviewData.effectiveDate) : ''
                  }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  <b>Expiry Date</b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text
                  class="pl-2"
                  tile
                >
                  {{
                    reviewData.expiryDate ?
                      formatDate(reviewData.expiryDate) : ''
                  }}
                </v-card-text>
              </v-col>
            </v-row>

            <v-col cols="12">
              <!-- :enableSearch="true" -->
              <h5 style="color:red !important">
                Please select related Coach in the following list and click save
              </h5>
              <user-list
                ref="selectCoachList"
                :user-list="coachList"
                :default-selected-list="selectedCoach"
                limit="3"
                :enable-search="true"
                @click="handleCoachClick"
                @remove="handleCoachRemove"
              >
              </user-list>
            </v-col>

            <v-col cols="12">
              <v-btn
                color="primary"
                block
                @click="nextButton"
              >
                Check/edit Commission
              </v-btn>
            </v-col>
          </v-container>
        </v-card-text>
      </v-card>
    </div>

    <div v-else-if="orderStepper == 5 && deleteDialog != true">
      <v-card-title
        v-if="calculated"
        style="word-break: break-word"
      >
        <span
          v-if="calculated"
          class="warning-commission"
        >
          <br>
          This section cant't change since commission has already calculated
        </span>
      </v-card-title>

      <v-snackbar
        v-model="snackbar"
        centered
        timeout="2000"
      >
        Total percentage must be equal 100%
      </v-snackbar>

      <swipe-list
        ref="swipecoachList"
        class="card"
        :disabled="!enabled"
        :items="coachCommissionList.items"
        item-key="id"
        :revealed.sync="revealed"
        :item-disabled="({ disabled }) => disabled"
        :disable-right-swipe="true"
      >
        <template v-slot="{ item, index, revealLeft, revealRight, close, revealed, disabled }">
          <v-row no-gutters>
            <v-col
              cols="9"
            >
              <v-list-item>
                <v-list-item-avatar>
                  <v-img
                    :src="avatarGetLink(item.userRecord.avatar)"
                    shape="circle"
                  />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-subtitle
                    style="font-weight: 100"
                    v-text="item.orderNo"
                  ></v-list-item-subtitle>
                  <v-list-item-title
                    class="font-weight-black"
                    v-text="item.userRecord.fullName"
                  ></v-list-item-title>
                  <v-list-item-title>
                    <v-slider
                      v-model="coachCommissionList.items[index].commissionPercentage"
                      :disabled="calculated"
                      step="1"
                      ticks
                    >
                    </v-slider>
                    {{ coachCommissionList.items[index].commissionPercentage }}%
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col
              cols="3"
            >
              <v-btn
                :disabled="calculated"
                tile
                style="height: 100%; width:100%; "
                color="#ff0000"
                @click="submitDeleteSalesman(item)"
              >
                <v-icon
                  large
                  color="white"
                >
                  mdi-trash-can
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </template>

        <!-- <template v-slot:right="{ item }">

      <div class="swipeout-action red"   @click="submitDelete(item)">

        <v-icon large color="white">mdi-trash-can</v-icon>

      </div>
    </template>   -->
        <template v-slot:empty>
          <div>
            <!-- change mockSwipeList to an empty array to see this slot in action  -->
            list is empty ( filtered or just empty )
          </div>
        </template>
      </swipe-list>

      <v-snackbar
        v-model="snackbar"
        centered
        timeout="2000"
      >
        Total percentage is more than 100%
      </v-snackbar>
    </div>
    <div v-else-if="orderStepper == 6">
      <v-row style="padding-top: 12px;">
        <v-col cols="12">
          <div class="pl-2">
            <span class="text-h9 wrap"><b>Select one or more sales and then click save icon</b><br></span>
          </div>
        </v-col>
        <!-- :enableSearch="true" -->
        <v-col cols="12">
          <user-list
            ref="selectTempSalesList"
            :user-list="tempSalesList"
            :default-selected-list="selectedSales"
            limit="3"
            :enable-search="true"
            @click="handleSalesClick"
            @remove="handleSalesRemove"
          ></user-list>
        </v-col>
      </v-row>
    </div>
    <div v-else-if="orderStepper == 7">
      <v-container class="card-container">
        <v-card
          class="scroll"
          style="width: 100%;"
        >
          <v-card-text>
            <RichEditor
              :current-data="termsConditionItemData"
              disable-button
            >
            </RichEditor>
          </v-card-text>
        </v-card>
      </v-container>
    </div>

    <div class="text-center">
      <v-dialog
        v-model="editDialog"
        persistent
        max-width="290"
      >
        <v-card>
          <v-card-title style="word-break: break-word">
            <span class="text-h5 wrap"><b>Transfer order from {{ oldCenter }} to {{ newCenter }}?</b><br></span>

            <span class="wrap editH1Dialog">
              <br>
              All existing incomplete course booking would be cancel if invalid for {{ newCenter }}
            </span>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="dark"
              text
              @click="editDialog = false"
            >
              Back
            </v-btn>
            <!-- color="green darken-1" -->
            <v-btn
              :loading="loading"
              color="blue"
              text
              @click="confirmSubmitEdit"
            >
              Confirm
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <div class="text-center">
      <v-dialog
        v-model="deleteDialog"
        width="600px"
      >
        <v-card>
          <v-card-title style="word-break: break-word">
            <span class="text-h5"><b>Void Order {{ reviewData.orderNo }}</b></span>
          </v-card-title>
          <v-card-text>
            <v-col cols="12">
              <v-text-field
                v-model="voidReason"
                label="Reason"
              ></v-text-field>
            </v-col>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="dark"
              text
              @click="deleteDialog = false"
            >
              Back
            </v-btn>
            <!-- color="green darken-1" -->
            <v-btn
              :loading="loading"
              color="dark"
              text
              @click="confirmSubmitDelete"
            >
              Confirm
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <!-- <v-btn v-if="orderStepper == 2" color="#4fdea4" absolute bottom right fab @click="submitDelete(reviewData)">
      <v-icon color="white">mdi-plus</v-icon>
    </v-btn> -->

    <v-btn
      v-if="orderStepper == 5 && calculated == false"
      color="#4fdea4"
      absolute
      bottom
      right
      fab
      @click="findOrderSales"
    >
      <v-icon color="white">
        mdi-plus
      </v-icon>
    </v-btn>

    <v-overlay
      :z-index="999"
      :value="progressLoading"
    >
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>

    <div class="text-center">
      <v-dialog
        v-model="deleteSalesmanDialog"
        width="600px"
      >
        <v-card v-if="tempItem != null">
          <v-card-title>
            <span class="wrap editH1Dialog"><b>Are you sure to delete
              {{ tempItem.userRecord.fullName }} in Order No: {{ reviewData.orderNo }}</b></span>
          </v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="dark"
              text
              @click="cancelDeleteSalesman"
            >
              Back
            </v-btn>

            <v-btn
              :loading="loading"
              color="dark"
              text
              @click="confirmSubmitDeleteSalesman"
            >
              Confirm
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <v-snackbar
      v-model="snackbarVoid"
      centered
      timeout="1000"
    >
      Please enter the void reason
    </v-snackbar>
  </div>
</template>

<script>
import {
  mdiAccountOutline,
  mdiDeleteOutline,
  mdiDotsVertical,
  mdiExportVariant,
  mdiFileDocumentOutline,
  mdiPlus,
  mdiSquareEditOutline,
} from '@mdi/js'
import { ref } from 'vue'
import * as moment from 'moment'
import { createItem, deleteItem, fetchHistoryList as fetchList, getItem, updateItem, commissionFetchList } from '@/api/salesOrder'
import { fetchList as centerFetchList } from '@/api/center'

// import css from '../../src/styles/vue-swipe-actions.css';
import {
  createItem as orderSalesmanCreateItem, deleteItem as commissionDeleteItem,
  updateItem as commissionUpdateItem, fetchList as orderSalesmanFetchList,
} from '@/api/orderSalesman'

import { fetchList as orderCoachFetchList, updateItem as orderCoachUpdateItem } from '@/api/orderCoach'

import CRUDTable from '@/components/CRUD/CRUDTable'
import { useStore } from '@/store'

import UniversalInput from '@/components/CRUD/UniversalInput.vue'
import SwipeList from '@/components/SwipeList/SwipeList.vue'
import UserList from '@/components/UserSelector/UserList'
import '@/styles/swipelist.css'
import RichEditor from '@/components/RichEditor/RichEditor.vue'
import { getItem as getTermsConditionItem } from '@/api/termsCondition'

import OrderPrintView from '../OrderPrintView.vue'

export default {
  name: 'OrderHistory',
  components: {
    CRUDTable,
    SwipeList,
    UniversalInput,
    UserList,
    OrderPrintView,
    RichEditor,
  },
  data() {
    return {
      enabled: true,
      page: 0,
      revealed: {},
      lastEventDescription: '',
      mockSwipeList: [
        [
          {
            id: 'a',
            title: 'Some title',
            description: 'some description',
            disabled: true,
          },
          {
            id: 'b',
            title: 'Some title',
            description: 'some description',
            disabled: false,
          },
          {
            id: 'c',
            title: 'Some title',
            description: 'some description',
            disabled: false,
          },
        ],
        [
          {
            id: 'd',
            title: 'Some title',
            description: 'some description',
            disabled: false,
          },
          {
            id: 'e',
            title: 'Some title',
            description: 'some description',
            disabled: false,
          },
          {
            id: 'f',
            title: 'Some title',
            description: 'some description',
            disabled: false,
          },
        ],
      ],
      titles: {
        1: 'Order History Search',
        2: 'Order List',
        3: 'Order Detail',
        4: '1. Assign Coach',
        5: '2. Assign Commission',
        6: 'Assign Salesman',
        7: 'Terms Conditions',
      },
      orderStepper: 1,

      // production
      fromDate: moment(Date.now()).clone().add('days', -180).format('YYYY-MM-DD'),
      toDate: moment(Date.now()).clone().add('days', 1).format('YYYY-MM-DD'),

      /// /test
      // fromDate:moment(Date.now()).format('YYYY-MM-DD'),
      //     toDate: moment(Date.now()).clone().add('days', 30).format('YYYY-MM-DD'),

      fromMenu: false,
      toMenu: false,
      searchKeyWord: '',
      searchCoachKeyWord: '',
      progress: false,
      content: [],
      reviewData: [],
      testitems: [
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me 2' },
      ],
      centerItems: [],
      tempCenterCode: '',

      inputCenterConfig:
      {
        propName: 'tempCenterCode',

        // label: 'Code',
        // defaultValue: 5,
        type: {
          name: 'select',
          items: [],
          itemText: 'code',
          itemValue: 'id',
        },
      },
      deleteDialog: false,

      deleteSalesmanDialog: false,

      voidReason: '',
      editDialog: false,
      oldCenter: '',
      newCenter: '',

      snackbar: false,

      coachCommissionList: [],

      tempSalesList: [],

      tempCoachList: [],
      coachList: [],
      selectedCoach: [],
      selectedSales: [],
      tempSelectedCoach: [],
      tempSelectedSales: [],

      calculated: false,
      orderID: 0,

      calculatedCheckBox: false,

      tempItem: null,

      snackbarVoid: false,
      termsConditionItemData: '',
    }
  },
  mounted() {
    // ideally should be in some global handler/store
    window.addEventListener('keydown', this.onKeyDown)
    window.addEventListener('keyup', this.onKeyUp)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.onKeyDown)
    window.removeEventListener('keyup', this.onKeyUp)
  },

  // mounted(){
  //   // this.$set(this.inputCenteConfig.type, 'items', this.centerItems)

  // },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },

    submitConditionPage() {
      this.progressLoading = true

      getTermsConditionItem(this.reviewData.termsID)
        .then(response => {
          this.termsConditionItemData = response.data.record.content
          this.orderStepper = 7
          this.scrollToTop()
          this.progressLoading = false
        })
        .catch(err => {
          this.progressLoading = false
        })
    },

    avatarGetLink(avatar) {
      if (avatar == undefined) {
        return ''
      }

      return process.env.VUE_APP_BASE_API + avatar
    },

    // #region PageControl
    backPrevious() {
      if (this.orderStepper == 7) {
        this.orderStepper = 3

        return
      }

      if (this.orderStepper == 5) {
      // this.fetehCoachDataForOrderStepper4()
        this.submitCommissionPage()
        this.getCalculated()

        this.snackbar = false

        return
      }

      if (this.orderStepper > 1) {
        this.orderStepper -= 1
      }
      if (this.orderStepper == 1) {
        this.content = []
      }
    },

    submitSearchWithoutChangeOrderStepper() {
      this.progressLoading = true

      //  loading.value = true
      fetchList({ page: 0, limit: 0, Todate: this.toDate, FromDate: this.fromDate, searchKeyWord: this.searchKeyWord , 
        searchCoachKeyWord : this.searchCoachKeyWord })
        .then(response => {
          this.progressLoading = false
          console.log('Order History response', response)
          this.content = response.data
          console.log('content value', this.content)

          // loading = false
        })
        .catch(err => {
          this.progressLoading = true

          // loading = false
        })
    },

    // #endregion

    // #region orderstepper1
    submitSearch() {
      this.orderStepper = 2
      this.scrollToTop()
      this.progressLoading = true

      //  loading.value = true
      fetchList({
        page: 0,
        limit: 0,
        Todate: this.toDate,
        FromDate: this.fromDate,
        searchKeyWord: this.searchKeyWord,
        searchCoachKeyWord : this.searchCoachKeyWord,
        OrderBy: 'id',
        OrderDesc: true,
        Calculated: this.calculatedCheckBox,
      })
        .then(response => {
          this.progressLoading = false
          console.log('Order History response', response)
          this.content = response.data
          console.log('content value', this.content)

          // loading = false
        })
        .catch(err => {
          this.progressLoading = false

          // loading = false
        })
    },

    // #endregion

    // #region orderstepper2
    edit(item) {
      console.log('edit', item)
      this.reviewData = item
      this.orderStepper = 3
      this.scrollToTop()
      this.orderID = item.id

      this.calculated = item.calculated

      centerFetchList({ page: 0, limit: 0 })
        .then(response => {
          console.log('center  response', response)
          this.centerItems = response.data.items
          this.inputCenterConfig.type.items.push(...this.centerItems)
          this.tempCenterCode = this.reviewData.centerID
        })
        .catch(err => {
          // loading = false
        })
    },

    // #endregion

    // #region orderstepper3
    submitLocation(item) {
      const oldObject = this.centerItems.find(object => object.id === this.reviewData.centerID)
      const newObject = this.centerItems.find(object => object.id === this.tempCenterCode)
      this.oldCenter = oldObject.code
      this.newCenter = newObject.code

      //  this.oldCenter
      //  this.oldCenter
      if (this.reviewData.centerID != this.tempCenterCode) {
        this.editDialog = true
      }
    },

    confirmSubmitEdit() {
      this.loading = true
      this.progressLoading = true
      this.reviewData.FromCenterID = this.reviewData.centerID
      this.reviewData.ToCenterID = this.tempCenterCode

      // this.editDialog = false
      // this.loading   = false
      this.reviewData.CenterID = this.tempCenterCode
      updateItem(this.reviewData)
        .then(response => {
          this.progressLoading = false
          this.editDialog = false
          this.loading = false
          this.submitSearchWithoutChangeOrderStepper()
          this.reviewData.FromCenterID = null
          this.tempCenterCode.ToCenterID = null
        })
        .catch(err => {
          this.progressLoading = false
          this.loading = false
          this.editDialog = false
        })
    },

    // submitCommissionPage() {
    //   this.orderStepper = 4

    //   this.fetchCoachdata()

    //   getItem(this.orderID).then(response => {

    //     this.calculated = response.data.record.calculated
    //   }).catch(err => {
    //   })

    //   console.log('submitCommissionPage')
    // },

    submitCommissionPage() {
      this.orderStepper = 4
      this.scrollToTop()

      this.fetehCoachDataForOrderStepper4()
    },

    // #endregion

    // #region orderstepper4
    fetehCoachDataForOrderStepper4() {
      this.progressLoading = true
      orderCoachFetchList({ SalesOrderID: this.reviewData.id }).then(response => {
        this.progressLoading = false
        const tempReponse = response.data.items
        this.tempCoachList = []
        this.coachList = []
        this.selectedCoach = []
        this.tempSelectedCoach = []
        this.tempCoachList = tempReponse

        //  this.coachList = [...tempReponse.filter(object => object.assignCoach === false)];
        this.coachList = [...tempReponse.filter(object => object.assignCoach === false)]

        console.log(' this.coachList = this.coachList.userRecord', this.coachList)
        this.selectedCoach = [...tempReponse.filter(object => object.assignCoach === true)]
        this.tempSelectedCoach = this.selectedCoach

        // this.tempCoachList = [...this.selectedCoach]
        // console.log(' this.tempCoachList = this.selectedCoach.userRecord', this.selectedCoach)
      })
        .catch(err => {
          this.progressLoading = false
        })
    },

    handleCoachClick(item) {
      // console.log('handleCoachClick',item)
      // this.selectedCoach.push(item)

      this.tempSelectedCoach.push(item)
      console.log('handleCoachClick', this.tempSelectedCoach)
    },
    handleCoachRemove(item) {
      const index = this.tempSelectedCoach.indexOf(item) // get the index of 'banana'
      if (index !== -1) {
        this.tempSelectedCoach.splice(index, 1) // remove the item at the found index
      }
      console.log('handleCoachRemove', this.tempSelectedCoach)
    },

    nextButton() {
      console.log('nextButton')
      this.orderStepper = 5
      this.scrollToTop()

      this.progressLoading = true

      this.fetchCoachdata()

      this.getCalculated()

      // this.fetchSalesData()
    },

    getCalculated() {
      getItem(this.reviewData.id).then(response => {
        this.calculated = response.data.record.calculated
      }).catch(err => {
      })
    },

    // #endregion

    // #region orderstepper5
    fetchCoachdata() {
      this.progressLoading = true

      // this.coachCommissionList = []
      commissionFetchList({ page: 0, limit: 0, orderNo: this.reviewData.orderNo })
        .then(response => {
          this.progressLoading = false
          console.log('commissionFetchList', response)
          this.coachCommissionList = response.data
        })
        .catch(err => {
          this.progressLoading = false

          // loading = false
        })
    },

    submitEdit() {
      if (this.calculated == false) {
        let percentageValue = 0
        console.log('aaa', this.coachCommissionList.items.length)
        for (let i = 0; i < this.coachCommissionList.items.length; i++) {
          console.log('this.coachCommissionList[i].CommissionPercentage', this.coachCommissionList.items[i].commissionPercentage)
          percentageValue += this.coachCommissionList.items[i].commissionPercentage
        }

        console.log('percentageValue', percentageValue)

        if (percentageValue == 100) {
          this.progressLoading = true
          console.log('this.coachCommissionList', this.coachCommissionList)

          orderCoachUpdateItem({ SalesOrderID: this.reviewData.id, UserRecord: this.tempSelectedCoach })
            .then(response => {
              this.orderStepper = 3
              this.scrollToTop()
            })
            .catch(err => {

            })

          // this.progressLoading = true
          commissionUpdateItem(this.coachCommissionList).then(response => {
            this.fetchCoachdata()

            getItem(this.orderID).then(response => {
              this.calculated = response.data.record.calculated
            }).catch(err => {
            })
          })
            .catch(err => {

            })
        } else {
          this.snackbar = true
        }
      }
    },

    submitDeleteSalesman(item) {
      console.log('submitDelete', item)
      this.tempItem = item
      this.deleteSalesmanDialog = true
    },

    cancelDeleteSalesman() {
      this.deleteSalesmanDialog = false
      this.tempItem = null
    },

    confirmSubmitDeleteSalesman() {
      this.progressLoading = true

      commissionDeleteItem(this.tempItem)
        .then(response => {
          this.deleteSalesmanDialog = false
          this.progressLoading = false

          this.fetchCoachdata()
        })
        .catch(err => {
          this.deleteSalesmanDialog = false
          this.progressLoading = false
        })
    },

    // #endregion

    // #region orderstepper5
    findOrderSales() {
      console.log('findOrderSales')
      this.orderStepper = 6
      this.scrollToTop()
      this.tempSelectedSales = []
      this.fetchSalesData()

      // this.progressLoading = true
    },

    fetchSalesData() {
      this.progressLoading = true
      this.tempSelectedSales = []
      orderSalesmanFetchList({ page: 0, limit: 0, SalesOrderID: this.reviewData.id })
        .then(response => {
          this.progressLoading = false
          this.tempSalesList = response.data.items
        })
        .catch(err => {
          this.progressLoading = false
        })
    },

    handleSalesClick(item) {
      this.tempSelectedSales.push(item)

      console.log('this.tempSelectedSales', this.tempSelectedSales)
    },

    handleSalesRemove(item) {
      const index = this.tempSelectedSales.indexOf(item) // get the index of 'banana'
      if (index !== -1) {
        this.tempSelectedSales.splice(index, 1) // remove the item at the found index
      }
      console.log('this.tempSelectedSales', this.tempSelectedSales)
    },

    submitSalesEdit() {
      console.log('submitSalesEdit', this.selectedSales)
      this.progressLoading = true
      orderSalesmanCreateItem({ SalesOrderID: this.reviewData.id, UserRecord: this.tempSelectedSales })
        .then(response => {
          this.tempSelectedSales = []
          this.fetchSalesData()
          this.fetchCoachdata()
          this.progressLoading = false
          this.orderStepper = 5
          this.scrollToTop()
        })
        .catch(err => {
          this.tempSelectedSales = []
          this.progressLoading = false
          this.orderStepper = 5
          this.scrollToTop()
        })
    },

    // #endregion

    submitDelete(item) {
      console.log('submitDeletessssssssssssss', item)
      this.deleteDialog = true

      this.reviewData = item
    },

    confirmSubmitDeleteSalesOrder() {
      this.loading = true
      this.progressLoading = true
      this.reviewData.voidReason = this.voidReason

      deleteItem(this.reviewData)
        .then(response => {
          this.progressLoading = false
          this.deleteDialog = false
          this.voidReason = ''
          this.loading = false
          this.submitSearch()
        })
        .catch(err => {
          this.progressLoading = false
          this.deleteDialog = false
          this.voidReason = ''
          this.loading = false
        })
    },

    confirmSubmitDelete() {
      if (this.voidReason != '') {
        this.loading = true
        this.progressLoading = true
        this.reviewData.voidReason = this.voidReason

        deleteItem(this.reviewData)
          .then(response => {
            this.progressLoading = false
            this.deleteDialog = false
            this.voidReason = ''
            this.loading = false
            this.submitSearch()
          })
          .catch(err => {
            this.progressLoading = false
            this.deleteDialog = false
            this.voidReason = ''
            this.loading = false
          })
      } else {
        this.snackbarVoid = true
      }
    },

    // region commmonService
    setLastEvent(name, { item, index }) {
      this.lastEventDescription = {
        name,
        index,
        id: item.id,
      }
    },

    // keyboard
    onKeyDown(e) {
      if (e.keyCode !== 16) return
      this.enabled = false
    },
    onKeyUp(e) {
      if (e.keyCode !== 16) return
      this.enabled = true
    },

    formatDate(date) {
      const d = new Date(date)
      let month = `${d.getMonth() + 1}`
      let day = `${d.getDate()}`
      const year = d.getFullYear()

      if (month.length < 2) { month = `0${month}` }
      if (day.length < 2) { day = `0${day}` }

      return [year, month, day].join('-')
    },

    // #endregion

    handlePrint() {
      console.log('handlePrint', this.$refs.orderPrintView)
      this.$refs.orderPrintView.printOrder()
    },
  },
  setup() {
    const loading = ref(false)
    const progressLoading = ref(false)

    return {
      loading,
      progressLoading,
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>

<style>
/* @import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"); */

.swipeout-padding {
  margin-left: -2%;
}

.centered {
  position: fixed;
  /* or absolute */
  top: 50%;
  left: 50%;
}

.editH1Dialog {
  color: red !important;
  font-size: 18px;
  width: 100%;
  /*Dont really required*/

  text-align: center;
  word-wrap: break-word;
}

.warning-commission {

  color: red !important;
  font-size: 12px;
  text-align: left;
  word-wrap: break-word;

}

.wrap {
  width: 100%;
  /*Dont really required*/
  text-align: center;
  word-wrap: break-word;
}

/* app specific styles */
.vcenter {
  display: flex;
  align-items: center;
  height: 56px;
}

.swipeout-action {
  display: flex;
  align-items: center;
  padding: 0 3rem;
  cursor: pointer;
  left: 0;

}

/* https://developer.apple.com/design/human-interface-guidelines/ios/visual-design/color/ */
.swipeout-action.blue {
  color: white;
  background-color: rgb(0, 122, 255);
}

.swipeout-action.blue:hover {
  background-color: darken(rgb(0, 122, 255), 5%);
}

.swipeout-action.purple {
  color: white;
  background-color: rgb(88, 86, 214);
}

.swipeout-action.purple:hover {
  background-color: darken(rgb(88, 86, 214), 5%);
}

.swipeout-action.red {
  color: white;
  background-color: rgb(255, 59, 48);
}

.swipeout-action.red:hover {
  background-color: darken(rgb(255, 59, 48), 5%);
}

.swipeout-action.green {
  color: white;
  background-color: rgb(76, 217, 100);
}

.swipeout-action.green:hover {
  background-color: darken(rgb(76, 217, 100), 5%);
}

.swipeout-list-item {
  flex: 1;
  border-bottom: 1px solid lightgray;
}

.swipeout-list-item:last-of-type {
  border-bottom: none;
}

.card {
  width: 100%;
  background-color: white;
  border-radius: 3px;
  box-shadow: none;
  border: 1px solid lightgray;
}

.card-content {
  padding: 1rem;
}

.transition-right {
  transform: translate3d(100%, 0, 0) !important;
}

.transition-left {
  transform: translate3d(-100%, 0, 0) !important;
  /* transform: translate3d(-100%, 0 ,0) !important; */
}

.toolbar {
  display: flex;
  align-items: center;
}

.toolbar .toolbar-section {
  flex: 0 0 auto;
}

.toolbar .toolbar-section--center {
  flex: 1000 1 0%;
}
</style>
